
'use strict';

/* Controllers */

module.exports = angular.module('superdostavka.baseCtrl', [])
.controller('BaseCtrl', ['$scope', '$rootScope', '$http', 'posManager', '$filter', 'modal', 'userManager', 'maxAuthManager', 'unibellAuthManager', function($scope, $rootScope, $http, posManager, $filter, modal, userManager, maxAuthManager, unibellAuthManager) {

    $scope.config = null;
	$scope.Math = Math;
	$scope.posManager = posManager;
	$scope.userManager = userManager;
	// Шаблон логина использует manager напрямую. Публикация в BaseCtrl нужна
	// обычному scope страницы; isolated scope директивы modal получает его отдельно.
	$scope.maxAuthManager = maxAuthManager;
	$scope.unibellAuthManager = unibellAuthManager;
	$scope.modal = modal;
	$scope.positions = {};
	$scope.sections = {};
	$scope.order = {};
	$scope.cart = {};
	$scope.cities = [];
	$scope.group_modifications = [];
	$scope.positionGroups = [];

	$scope.init = function()
	{
	    $scope.config = $scope.getConfig();

		$scope.posManager.init();
		$scope.userManager.getUser();
	}

    $scope.getConfig = function()
	{
	    let apiUrl = '/rapi/getConfig';
        if ($scope.city && $scope.city.id) {
            apiUrl += '?city_id=' + $scope.city.id;
        }
        return $http.get(apiUrl).success(function(data) {
			// $scope.getToken('authenticate');
			// $scope.bonuses = data.bonuses;
			// $scope.discounts = data.discounts;
			// $scope.limits = data.limits;
			// $scope.minSum = data.minSum;
			$scope.pickupAddresses = data.pickup_addresses;
			$scope.common = data.common;
			$scope.cities = data.cities;
            $scope.delivery_prediction = data.delivery_prediction || {enabled: false, test_mode: false};

			if (data.group_modifications !== undefined) {
                $scope.group_modifications = data.group_modifications;
            }

			return data;

			// $scope.getAction();
			// $scope.makeDiscount();
		});
	}


	$scope.toggleModal = function(modal, withOthers, hiddenLayout)
	{
	  	$scope.modal.toggle(modal, withOthers, hiddenLayout);
	}

	$scope.setModalPos = function(id)
	{
      $scope.modalPos = posManager.getPosition(id);
      // console.log(id);
      // console.log(id);
      // console.log(posManager.getPosition(id));
      // console.log(posManager.positions['position_'+id]);
      modal.toggle('posImage');
    }

	$scope.notSorted = function(obj, reverse = false)
	{
        if (!obj) {
            return [];
        }

        obj = Object.keys(obj);

        return reverse ? obj.reverse() : obj;
    }

    $scope.filter = function(param, filters)
	{
        for(var i in filters)
        {
        	if(!$filter(filters[i])(param))
        		return false;
        }

        return true;
    }

    $scope.login = function()
    {
      userManager.login().then(function(res){
      	if(res && (!res.data.errors || res.data.errors.length == 0)) {
            $scope.toggleModal('login');
        }

      });
    }


    $scope.hideAppsBanner = function (type = 'header') {
	    let headerAppsBanner = document.getElementById('headerAppsBanner');
	    let hideAppsFullSizeBanner = document.getElementById('hideAppsFullSizeBanner');

	    if (headerAppsBanner && type === 'header') {
	        headerAppsBanner.style.display = 'none';
        }

	    if (hideAppsFullSizeBanner && type === 'fullSize') {
            hideAppsFullSizeBanner.style.display = 'none';
        }

        document.documentElement.style.overflow = "auto";
        document.body.style.overflow = "auto";

        $http.get('/rapi/hideAppsBanner/' + type,).success(function() {
            //
        });
    }

    $scope.setSticked = function(sticked)
    {
      if (document.getElementById("div-fixed-stick") !== null) {
          // console.log(sticked)
          if($scope.navSticked == true && sticked == false)
          {
              document.getElementById("div-fixed-stick").className = 'ng-hide';
          } else if($scope.navSticked == false && sticked == true)
          {
              document.getElementById("div-fixed-stick").className = '';
          }

          $scope.navSticked = sticked;
      }
    }

    $scope.getModGroups = function(positionId) {
	    let position = $scope.posManager.getPosition(positionId);

        if ($scope.positionGroups[positionId] === undefined || !$scope.positionGroups[positionId].length) {
            $scope.positionGroups[positionId] = [];
            for (let i in $scope.group_modifications) {
                if (position.grouped_mods.indexOf($scope.group_modifications[i].id) !== -1) {
                    if (position.current_group_mod === undefined) {
                        position.current_group_mod = $scope.group_modifications[i].id;
                    }

                    $scope.positionGroups[positionId].push({
                        id: $scope.group_modifications[i].id,
                        name: $scope.group_modifications[i].name,
                        group_name: $scope.group_modifications[i].group_name,
                    });
                }
            }
        }

        return $scope.positionGroups[positionId];
    }

    $scope.setCurrentGroupMod = function(positionId, groupId) {
        let position = $scope.posManager.getPosition(positionId);
        position.current_group_mod = groupId;

        if (position.active_mod) {
            let mods = position.grouped_mods.filter(i => i === groupId);

            if (mods && (position.active_mod + 1) > mods.length) {
                position.active_mod = 0;
            }
        }
    }


    $scope.redirectToVL = function () {
        let vlForm = document.createElement("form");
        vlForm.action = "https://www.vl.ru/eda/external/royalburger/order";
        vlForm.method = "post";

        let phone = document.createElement("input");
        phone.value = userManager.user.username;
        phone.name = "phone";

        vlForm.appendChild(phone);

        for (let i in posManager.positions) {
            let pos = posManager.positions[i];

            if (pos.quantity == 0) {
                continue;
            }

            let product = document.createElement("input");
            product.value = pos.quantity;
            product.name = "positons[" + pos.id + "]";

            vlForm.appendChild(product);
        }
        document.body.appendChild(vlForm);
        vlForm.submit();

        return;
    }

}]);

// angular.module('myApp.controllers', ['ngResource', 'ngRoute'])
// .controller('LoginCtrl', function($scope, $rootScope, $http, userManager) {
//
// 	$scope.userManager = userManager;
//
//     $scope.toggleCart = function()
//     {
//       $scope.showCart = !$scope.showCart;
//     }
// });
